import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import BaseInput from '@/components/form/base/BaseInput.tsx';
import InputError from '@/components/form/base/InputError.tsx';

const EmailInput = ({
  label,
  register,
  required = false,
  error,
}: {
  label: string;
  register: UseFormRegisterReturn;
  required?: boolean;
  error?: string;
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <InputLabel label={label} required={required} />
      <BaseInput
        type="email"
        register={register}
        placeholder="hello@campdesk.pl"
        error={error}
      />
      <InputError error={error} />
    </div>
  );
};

export default EmailInput;
